import React, { Component, createRef } from "react";
import PropTypes from "prop-types";

// Styles import for this component
import "nouislider/distribute/nouislider.min.css";
import "./slider-input.styles.scss";

import $noUiSlider from "nouislider";

export class NoUiSliderElement extends Component {
  constructor(...props) {
    super(...props);

    this.sliderNode = createRef();
    this.sliderInstance = null;
    this.onValueUpdate = this.onValueUpdate.bind(this);
  }

  getInRangeValue(value) {
    const { min, max } = this.props;

    return value <= max && value >= min ? value : value > max ? max : min;
  }

  componentDidMount() {
    this.mountSlider();
    this.bindEvents();
  }

  componentWillUnmount() {
    this.unmountSlider();
  }

  getPips() {
    const labels = this.getLabels();
    const formatter = this.getFormatter();
    const scaleCourve = this.getScaleCourve();

    return {
      mode: "range",
      density: 5,
      format: {
        to:
          labels.min || labels.max
            ? labelsScaleFormatter(scaleCourve, labels, formatter)
            : formatter,
        from:
          labels.min || labels.max
            ? labelsScaleFormatter(scaleCourve, labels, formatter)
            : formatter,
      },
    };
  }

  getTooltips() {
    const formatter = this.getFormatter();
    return [{ from: formatter, to: formatter }];
  }

  mountSlider() {
    const { current: sliderNode } = this.sliderNode;

    if (!sliderNode) {
      return;
    }

    $noUiSlider.create(sliderNode, {
      start: this.props.start,
      range: this.getScaleCourve(),
      step: this.getStep(),
      orientation: "horizontal",
      connect: "lower",
      tooltips: this.getTooltips(),
      pips: this.getPips(),
    });

    this.sliderInstance = sliderNode.noUiSlider;
  }

  unmountSlider() {
    if (!this.sliderInstance) {
      return;
    }

    this.sliderInstance.destroy();
  }

  bindEvents() {
    const { sliderInstance } = this;

    if (!sliderInstance) {
      return;
    }

    sliderInstance.on("update", values => this.onValueUpdate(values));
  }

  onValueUpdate(values) {
    const value = this.getInRangeValue(+values[0]);

    if (typeof this.props.onUpdate === "function") {
      this.props.onUpdate(value);
    }
  }

  getFormatter() {
    return valueFormatter[this.props.valueFormat];
  }

  getStep() {
    return +this.props.step || 1;
  }

  getLabels() {
    const { minLabel, maxLabel } = this.props;
    return {
      min: minLabel || null,
      max: maxLabel || null,
    };
  }

  getScaleCourve() {
    const { scaleCourve, min, max } = this.props;

    return (
      scaleCourve || {
        min,
        max,
      }
    );
  }

  render() {
    return <div ref={this.sliderNode} />;
  }
}

NoUiSliderElement.propTypes = {
  valueFormat: PropTypes.oneOf(["integer", "currency"]).isRequired,
  scaleCourve: PropTypes.object,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  start: PropTypes.number.isRequired,
  onUpdate: PropTypes.func,
};

// helper

const numberFormat = new Intl.NumberFormat("de-CH", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const currencyFormat = new Intl.NumberFormat("de-CH", {
  style: "currency",
  currency: "CHF",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const valueFormatter = {
  integer(value) {
    return numberFormat.format(Math.round(value));
  },
  currency(value) {
    return currencyFormat.format(value);
  },
};

function labelsScaleFormatter(range, labels, fallbackFormatter) {
  const labelMap = {
    [range.min]: labels.min,
    [range.max]: labels.max,
  };

  return function (value) {
    return typeof labelMap[value] !== "undefined"
      ? labelMap[value]
      : fallbackFormatter(value);
  };
}
